import React from 'react';
import { BiCopy } from 'react-icons/bi';

import { useDispatch } from 'src/store/useDispatch';
import { setAppAlert } from 'src/store/slice/appAlert';
import { shortenString } from 'src/components/Table/helpers';

import { CopyButton, DetailValue } from './styled';

type CopyableValueProps = {
  value?: string | null;
  /** Truncate the middle of long values (addresses, ids). */
  shorten?: boolean;
  /** Shown when there is no value; the copy button is hidden in that case. */
  placeholder?: string;
  /** Names the field in the confirmation toast, e.g. "Transaction ID copied". */
  label?: string;
};

/** A detail value with a one-click copy affordance next to it. */
const CopyableValue: React.FC<CopyableValueProps> = ({
  value,
  shorten = true,
  placeholder = '—',
  label,
}) => {
  const dispatch = useDispatch();
  const text = value ? String(value) : '';

  if (!text) {
    return <DetailValue $muted>{placeholder}</DetailValue>;
  }

  return (
    <DetailValue>
      <span title={text}>{shorten ? shortenString(text) : text}</span>
      <CopyButton
        type="button"
        aria-label={label ? `Copy ${label.toLowerCase()}` : 'Copy to clipboard'}
        title={label ? `Copy ${label.toLowerCase()}` : 'Copy to clipboard'}
        onClick={() => {
          navigator.clipboard.writeText(text);
          dispatch(
            setAppAlert({
              message: label ? `${label} copied` : 'Copied to clipboard',
              isSuccess: true,
            }),
          );
        }}
      >
        <BiCopy size={16} />
      </CopyButton>
    </DetailValue>
  );
};

export default CopyableValue;
